module.exports = __webpack_public_path__ + "img/warning.47e88432.png";